import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { ColumnDef } from "@tanstack/react-table";

import StatusLight from "@/components/StatusLight";
import type { DriverRow } from "@/types/driver";
import ColumnHeader from "../ui/ColumnHeader";
import type { ColumnFilterOptions } from ".";
import { minWidthForColumnHeader } from "./columnMinWidth";
import { formatHandsFreeAvailability, isHandsFreeHeartbeatOffline } from "./handsFreeAvailability";

const TOOLTIP_ENTER_DELAY_MS = 1500;

function DriverHandsFreeAvailabilityCell({ driver }: { driver: DriverRow }) {
  if (isHandsFreeHeartbeatOffline(driver.mostRecentHandsFreeStatusUpdatedAt)) return null;

  const display = formatHandsFreeAvailability(driver);
  if (!display) return null;

  return (
    <Tooltip title={display.tooltip} enterDelay={TOOLTIP_ENTER_DELAY_MS} enterNextDelay={TOOLTIP_ENTER_DELAY_MS}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <StatusLight color={display.color} size={10} />
        <Box>{display.label}</Box>
      </Box>
    </Tooltip>
  );
}

const STATUS_COLUMN_TITLE = "Hands-free Availability";

export function statusColumn(options: ColumnFilterOptions): ColumnDef<DriverRow> {
  return {
    accessorFn: (row) => row.calculatedAvailability ?? "",
    id: "status",
    header: () => (
      <ColumnHeader
        title={STATUS_COLUMN_TITLE}
        extra={options.getColumnExtra("status")}
        isActive={options.isFilterActive("status")}
      />
    ),
    cell: ({ row }) => <DriverHandsFreeAvailabilityCell driver={row.original} />,
    meta: { flex: 2, draggable: true },
    minSize: minWidthForColumnHeader(STATUS_COLUMN_TITLE, { draggable: true, hasFilter: true }),
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
